<template>
  <a-modal modal-id="add-project">
    <div slot="title">Add Project</div>
    <div slot="form">
      <div class="row">
        <label>Name</label>
        <input type="text" class="form-control" v-model="newProject.name">
      </div>
      <div class="row">
        <label>Unique Slug</label>
        <input type="text" class="form-control" v-model="newProject.slug">
      </div>
      <div class="row m-t-xs">
        <label>Clients</label>
        <v-select :options="f.clients" label="name" index="id" v-model="newProject.client" @change="getGroups"></v-select>
      </div>
      <div class="row m-t-xs" v-if="filteredGroups.length">
        <label>Group:</label>
        <v-select :options="filteredGroups" label="name" index="id" v-model="newProject.group"></v-select>
      </div>
      <div class="row m-t-xs">
        <label>Description</label>
        <textarea class="form-control" placeholder="Describe your project in a few sentences" cols="30" rows="5" v-model="newProject.description"></textarea>
      </div>
      <div class="row m-t-xs">
        <label>Departments</label>
        <v-select multiple :options="departments" label="label" index="index" v-model="newProject.departments"></v-select>
      </div>
      <div class="row m-t-xs">
        <label>Project Manager</label>
        <v-select :options="users" label="username" index="id" v-model="newProject.manager"></v-select>
      </div>
      <div class="row m-t-xs">
        <label>Participants</label>
        <v-select multiple :options="users" label="username" index="id" v-model="newProject.participants"></v-select>
      </div>
      <div class="row m-t-xs">
        <label>Status</label>
        <v-select :options="statuses" label="label" index="index" v-model="newProject.status"></v-select>
      </div>
      <div class="row m-t-xs">
        <label>Priority</label>
        <v-select :options="priorities" label="label" index="index" v-model="newProject.priority"></v-select>
      </div>
      <div class="row m-t-xs">
        <label>Tags</label>
        <v-select multiple taggable push-tags v-model="newProject.tags"></v-select>
      </div>
      <div class="row m-t-xs">
        <label>Deadline</label>
        <input type="date" v-model="newProject.targetDate" min="0" class="pretty-input form-control">
      </div>
      <div class="row m-t-sm">
        <label for="file">Files</label>
        <input class="form-control" type="file" id="project-modal-file" ref="projectFile" multiple  @change="handleFileChange"/>
      </div>
      <div class="row m-t-xs">
        <label>Data</label>
        <data-interface :target="newProject.data" :returnType="'object'"></data-interface>
      </div>
    </div>
    <div slot="footer">
      <button class="btn btn-primary pull-right" @click="addProject"><i class="fa fa-plus m-r-xs"></i>Add Project</button>
    </div>
  </a-modal>
</template>
<script>
import { mapGetters } from 'vuex'
import KeyValueInterface from '../../../Helpers/Modal/KeyValueInterface.vue'
import { useProjectStore } from '../../../../stores/ProjectStore'
import { useDataStore } from '../../../../stores/DataStore'
import { storeToRefs } from 'pinia'
import { useTaskStore } from '../../../../stores/TaskStore'

export default {
  setup () {
    const projectStore = useProjectStore()
    const taskStore = useTaskStore()
    const data = useDataStore()

    data.loadDepartments()
    const { departments } = storeToRefs(data)
    if (!departments.length) data.loadDepartments()

    const statuses = taskStore.taskStatuses
    const priorities = taskStore.taskPriorities
    return { projectStore, departments, statuses, priorities }
  },
  data () {
    return {
      newProject: { name: '', slug: '', data: {} },
      selectedFiles: null,
      filteredGroups: []
    }
  },
  components: {
    dataInterface: KeyValueInterface
  },
  computed: {
    ...mapGetters({
      dataStructure: 'getData',
      f: 'getFilters',
      users: 'getUsers'
    })
  },
  mounted () {
    if (!this.f.clients) {
      this.$store.dispatch('loadFilters')
    }
  },
  methods: {
    handleFileChange () {
      this.selectedFiles = this.$refs.projectFile.files
    },
    initNewProject () {
      this.newProject = { name: '', slug: '', data: {} }
      this.selectedFiles = null
    },
    getGroups () {
      this.filteredGroups = this.f.groups.filter(g => g.client.id === this.newProject.client)
    },
    async createFormData () {
      const formData = new FormData()
      Object.keys(this.newProject).forEach(k => {
        if (k !== 'selectedFiles') {
          const val = typeof this.newProject[k] === 'object' ? JSON.stringify(this.newProject[k]) : this.newProject[k]
          formData.append(k, val)
        }
      })
      for (let i = 0; i < this.$refs.projectFile.files.length; i++) {
        let file = this.$refs.projectFile.files[i]
        formData.append(`files[${i}]`, file)
      }
      return formData
    },
    async addProject () {
      if (!this.newProject.name.trim().length || !this.newProject.slug.trim().length) {
        this.$toastr.warning('Name and slug cannot be empty')
        return
      }
      try {
        Object.keys(this.newProject).forEach(k => [null, undefined, ''].includes(this.newProject[k]) && delete this.newProject[k])

        if (this.selectedFiles) {
          const formData = await this.createFormData()
          await this.projectStore.addProject(formData)
          this.$refs.projectFile.value = null
        } else {
          await this.projectStore.addProject(this.newProject)
        }

        this.projectStore.loadProjects()
        this.initNewProject()
        $('#add-project').modal('hide')
        this.$toastr.success('Project created!', 'Success')
      } catch (error) {
        this.$toastr(error, 'Adding project failed')
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Pages/TaskManager/Projects/AddProjectModal.vue